import styled from "styled-components";

export const TitleRow = styled.div` 
    display: flex;
    gap: 15px;
    margin-bottom: 8px;
`